import { Slot, Stack } from 'expo-router';

/**
 * Web-only: omit the nested stack header (page title + close) on static pages.
 * The root stack provides AppHeader on web for these routes (see routes/_layout.tsx).
 * Native keeps _layout.tsx with getScreenTitleHeader so the title bar and dismiss remain.
 */
export default function StaticPageLayoutWeb() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Slot />
    </Stack>
  );
}
